import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { GlobalProvider } from "../../providers/global/global";
import { OrdersProvider } from '../../providers/orders/orders';

/**
 * Generated class for the TransRejectionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
    segment: 'trans-rejection'
})
@Component({
  selector: 'page-trans-rejection',
  templateUrl: 'trans-rejection.html',
})
export class TransRejectionPage {
	orders: any;

	//Pagination
	res: any; //Pagination data
	p: number = 1;
    per_page: number;
    total: number;
	loading: any;


  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController
, public loadingCtrl: LoadingController
, public toastCtrl: ToastController, public global: GlobalProvider, 
    public orderService: OrdersProvider) {
  }

  ionViewDidLoad() {
  	this.getPage(1);
  }

  refreshOrders() {
    this.getPage(1);
  }

  completeImage(image){
    this.orderService.completePreProcessingImageRejection(image).then((data: any) => {
        console.log('DATAA from COMPLETE ORDER:', data);
          this.fireToast(data.message);
          this.loading.dismiss();

    }, (err) => {
        this.loading.dismiss();
        console.log("Error in Order completion", err);
        this.fireToast(err.json().message);
    });
  }

  getPage(page: number) {
    this.showLoader();
    this.orderService.getPreProcessingRejectionOrders(page, false).then((data: any) => {
        console.log('DATAA from Page:', data);
          this.res = data;
          this.orders = data.data;
          

          this.total = this.res.total;
          this.per_page = this.res.per_page;
          this.p = this.res.current_page;

          const perPage = 10;
          const start = (page - 1) * perPage;
          const end = start + perPage;

          this.loading.dismiss();

    }, (err) => {
        this.loading.dismiss();
        console.log("not allowed_____");
        console.log(err);
    });


    }

  pageChanged(event){
    this.getPage(event);
  }
 showLoader(){
 
    this.loading = this.loadingCtrl.create({
      content: 'Loading...'
    });
 
    this.loading.present();
 
  }
fireToast(message: string) {
    console.log('fire toast!');
    let toast = this.toastCtrl.create({
                                    message: message,
                                    duration: 3000,
                                    position: 'bottom'
                                  });
                toast.present();
  }
fireAlert(message: string) {
    let alert = this.alertCtrl.create({
                                    message: message,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/trans-rejection/trans-rejection.ts